"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outputs = exports.VolatilityAdjustmentType = exports.DiscountingType = exports.TimeStampSelectionType = exports.InputVolatilityType = exports.AxisUnit = exports.LayoutFormat = exports.PriceSide = void 0;
var ipa_1 = require("../ipa");
Object.defineProperty(exports, "PriceSide", { enumerable: true, get: function () { return ipa_1.PriceSide; } });
var LayoutFormat;
(function (LayoutFormat) {
    LayoutFormat["Matrix"] = "Matrix";
    LayoutFormat["List"] = "List";
    LayoutFormat["NDimensionalArray"] = "NDimensionalArray";
})(LayoutFormat || (exports.LayoutFormat = LayoutFormat = {}));
var AxisUnit;
(function (AxisUnit) {
    AxisUnit["Date"] = "Date";
    AxisUnit["Strike"] = "Strike";
    AxisUnit["Tenor"] = "Tenor";
    AxisUnit["Delta"] = "Delta";
    AxisUnit["Moneyness"] = "Moneyness";
    AxisUnit["Expiry"] = "Expiry";
})(AxisUnit || (exports.AxisUnit = AxisUnit = {}));
var InputVolatilityType;
(function (InputVolatilityType) {
    InputVolatilityType["Default"] = "Default";
    InputVolatilityType["LogNormalVolatility"] = "LogNormalVolatility";
    InputVolatilityType["NormalizedVolatility"] = "NormalizedVolatility";
})(InputVolatilityType || (exports.InputVolatilityType = InputVolatilityType = {}));
var TimeStampSelectionType;
(function (TimeStampSelectionType) {
    TimeStampSelectionType["Default"] = "Default";
    TimeStampSelectionType["Open"] = "Open";
    TimeStampSelectionType["Close"] = "Close";
    TimeStampSelectionType["Settle"] = "Settle";
})(TimeStampSelectionType || (exports.TimeStampSelectionType = TimeStampSelectionType = {}));
var DiscountingType;
(function (DiscountingType) {
    DiscountingType["OisDiscounting"] = "OisDiscounting";
    DiscountingType["LiborDiscounting"] = "LiborDiscounting";
})(DiscountingType || (exports.DiscountingType = DiscountingType = {}));
var VolatilityAdjustmentType;
(function (VolatilityAdjustmentType) {
    VolatilityAdjustmentType["PbUndefined"] = "PbUndefined";
    VolatilityAdjustmentType["ConstantCaplet"] = "ConstantCaplet";
    VolatilityAdjustmentType["NormalizedCaplet"] = "NormalizedCaplet";
    VolatilityAdjustmentType["ConstantCap"] = "ConstantCap";
    VolatilityAdjustmentType["NormalizedCap"] = "NormalizedCap";
    VolatilityAdjustmentType["ShiftedCap"] = "ShiftedCap";
})(VolatilityAdjustmentType || (exports.VolatilityAdjustmentType = VolatilityAdjustmentType = {}));
var Outputs;
(function (Outputs) {
    Outputs["Headers"] = "Headers";
    Outputs["DataType"] = "DataType";
    Outputs["Data"] = "Data";
    Outputs["Statuses"] = "Statuses";
    Outputs["ForwardCurve"] = "ForwardCurve";
    Outputs["CalibrationParameters"] = "CalibrationParameters";
    Outputs["Constituents"] = "Constituents";
    Outputs["Dividends"] = "Dividends";
    Outputs["InterestRateCurve"] = "InterestRateCurve";
    Outputs["GoodnessOfFit"] = "GoodnessOfFit";
    Outputs["UnderlyingSpot"] = "UnderlyingSpot";
    Outputs["DiscountCurve"] = "DiscountCurve";
    Outputs["Description"] = "Description";
    Outputs["MoneynessStrike"] = "MoneynessStrike";
})(Outputs || (exports.Outputs = Outputs = {}));
